import React from 'react';

import { GeneratedReportsType } from './types';
import { initialContextValue } from './consts';

export const GeneratedReportsContext = React.createContext<GeneratedReportsType>(initialContextValue);
